import jMoment from "moment-jalaali";
import React, { useEffect, useState } from "react";
import { MobileTimePicker } from "@mui/x-date-pickers";
import { digitsFaToEn } from "@persian-tools/persian-tools";

const TimeWidget = (props) => {
  const { value, schema, onChange } = props;
  const [date, setDate] = useState(null);
  const [flag, setFlag] = useState(true);

  const formattedDate = (x) => digitsFaToEn(jMoment(x).format("HH:mm:ss"));

  const onAccept = (date) => {
    setFlag(false);
    setDate(date);
    onChange(formattedDate(date));
  };

  useEffect(() => {
    if (flag && value) {
      const val = value.split(":");
      return onAccept(
        digitsFaToEn(
          jMoment(new Date().setHours(val[0], val[1])).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        )
      );
    }
  }, [value]);

  return (
    <MobileTimePicker
      format="HH:mm"
      onAccept={onAccept}
      label={schema.title}
      sx={{ direction: "rtl" }}
      value={date && jMoment(date)}
      slotProps={{
        desktopPaper: {
          dir: "rtl",
        },
        mobilePaper: {
          dir: "rtl",
        },
      }}
    />
  );
};

export default TimeWidget;
